import { toast } from 'core/components/common/Toast'
import { IPromptHistory } from 'core/interfaces/PromptHistory'
import { useRetrievePromptHistoriseMutation } from 'lauria/api/promptHistorise'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

export const RETRIEVE_CHOICE_PROMPT = 'prompt' as const
export const RETRIEVE_CHOICE_PROMPT_AND_DOCUMENTS =
  'promptAndDocuments' as const

export type RetrieveChoice =
  | typeof RETRIEVE_CHOICE_PROMPT
  | typeof RETRIEVE_CHOICE_PROMPT_AND_DOCUMENTS

export const useRetrievePrompt = (
  promptHistory: IPromptHistory | null,
  setOpen: (open: boolean) => void,
  open: boolean,
  refetchPrompt: () => void
) => {
  const { t } = useTranslation()
  const [retrievePromptHistorise] = useRetrievePromptHistoriseMutation()
  const [isLoading, setIsLoading] = useState(false)
  const {
    handleSubmit,
    reset,
    formState: { errors },
    register,
  } = useForm<{ choice: RetrieveChoice | null }>({
    defaultValues: {
      choice: null,
    },
    mode: 'onSubmit',
  })

  const choiceRegister = register('choice', {
    required: true,
  })

  const onSubmit = handleSubmit(async (data) => {
    if (promptHistory?.id) {
      try {
        setIsLoading(true)
        await retrievePromptHistorise({
          promptHistoriseId: promptHistory.id,
          keepDocuments: data.choice !== RETRIEVE_CHOICE_PROMPT_AND_DOCUMENTS,
        })
      } catch (error) {
        console.error(error)
        toast.error(t('prompts.historise.retrievePromptModal.error'))
      } finally {
        refetchPrompt()
        setIsLoading(false)
        setOpen(false)
        reset()
        toast.success(t('prompts.historise.retrievePromptModal.success'))
      }
    }
  })

  useEffect(() => {
    if (open) reset()
  }, [open, reset])

  const hide = () => {
    reset()
    setOpen(false)
  }

  return {
    register: { choice: choiceRegister },
    errors,
    hide,
    onSubmit,
    isLoading,
  }
}
